const s=":host{display:flex}";export{s as default};
